import { render, staticRenderFns } from "./WeeklySubscriptionForm.vue?vue&type=template&id=36239a86&"
import script from "./WeeklySubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./WeeklySubscriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports